import React, { memo } from 'react';

import { Drawer } from '@mui/material';
import PushNotificationPanel from 'app/pages/pushNotifications/PushNotificationPanel';
import PropTypes from 'prop-types';

import { NOTIFICATIONS_SHEET_PAPER_PROPS } from './NotificationsSheet.constants';
import { NotificationsSheetTestIds } from './NotificationsSheet.testIds';

/**
 * Full-screen right-side drawer that surfaces the notification center on mobile.
 * Reuses `PushNotificationPanel` (the same content rendered by `PushNotificationBell`
 * on desktop) — no content is duplicated.
 *
 * @param {Object} props
 * @param {boolean} props.isOpen
 * @param {Function} props.onClose
 */
const NotificationsSheet = ({ isOpen, onClose }) => (
  <Drawer
    PaperProps={NOTIFICATIONS_SHEET_PAPER_PROPS}
    anchor="right"
    data-testid={NotificationsSheetTestIds.DRAWER}
    open={isOpen}
    onClose={onClose}
  >
    <PushNotificationPanel withBackButton onClose={onClose} />
  </Drawer>
);

NotificationsSheet.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default memo(NotificationsSheet);
